/**
 * ZITELOU - Main Layout
 * Layout principal avec Navbar et Sidebar
 */

import React, {useEffect, useState} from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const MainLayout = () => {
  // Sur mobile, sidebar fermée par défaut. Sur desktop, ouverte par défaut
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            const desktop = window.innerWidth >= 1024;
            setIsDesktop(desktop);
            // Open sidebar by default on desktop without forcing it on every toggle
            if (desktop) {
                setSidebarOpen((prev) => (prev ? prev : true));
            }
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Sidebar */}
        {(!isDesktop || sidebarOpen) && (
            <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        )}
      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Navbar */}
        <Navbar onToggleSidebar={toggleSidebar} />

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
